// import { LoginResponse } from './../../api/interfaces/Login';
import ContractService, { smsAuthType } from '@src/api/services/contractService';
import RootState from '@src/interfaces/RootState';
import dayjs from 'dayjs';
import { put, select } from 'redux-saga/effects';
import { SET_ERROR_OBJECT } from '../error/actions';
import { SET_LOADING } from './../ui/actions';
import { CustomerModel } from '@src/api/models/CustomerModel';
import { Customer } from '@src/api/interfaces/Customer';
import { AccountHolderModel } from '@src/api/models/AccountHolderModel';
import { AccountHolder } from '@src/api/interfaces/AccountHolder';
import UnitService from '@src/api/services/UnitService';
import { BankAccountModel } from '@src/api/models/BankAccountModel';
import { BankAccount } from '@src/api/interfaces/BankAccount';
import { PartnerModel } from '@src/api/models/PartnerModel';
import { ProductModel } from '@src/api/models/ProductModel';
import { change } from 'redux-form';
import { GET_PARTNER_LIST, GET_PRODUCT_BRAND_LIST, GET_PRODUCT_GROUP_LIST, GET_SHOP_LIST, GET_WARRANTY_LIST } from '../unit/actions';
import { ContractDataModel } from '@src/api/models/ContractDataModel';
import { ContractData } from '@src/api/interfaces/ContractData';
import { setNotification } from '@src/components/ui/Notifications';
import i18next from 'i18next';
// import { setNotification } from '@src/components/ui/Notifications';

/** Saga Actions */
export const SAVE_NEW_CONTRACT = 'SAVE_NEW_CONTRACT';
export const SAVE_MODIFIED_CONTRACT = 'SAVE_MODIFIED_CONTRACT';
export const VERIFY_SMS_CODE = 'VERIFY_SMS_CODE';
export const SEND_MAIL = 'SEND_MAIL';
export const SEND_SMS = 'SEND_SMS';
export const GET_PROJECT_PROPERTIES = 'GET_PROJECT_PROPERTIES';
export const GET_CONTRACT = 'GET_CONTRACT';
export const GET_ACCOUNT = 'GET_ACCOUNT';
export const GET_DIARIES = 'GET_DIARIES';
export const GET_TERMS_CONDITIONS = 'GET_TERMS_CONDITIONS';
export const GET_DEVICE = 'GET_DEVICE';
export const GET_BANK_LIST = 'GET_BANK_LIST';
export const GET_ATTRIBUTES = 'GET_ATTRIBUTES';
export const GET_DYNAMIC_DATA = 'GET_DYNAMIC_DATA';

/** Reducer Actions */
export const SET_PROJECT_PROPERTIES = 'SET_PROJECT_PROPERTIES';
export const SET_DIARIES = 'SET_DIARIES';
export const SET_CONTRACT_SAVED = 'SET_CONTRACT_SAVED';
export const SET_PRODUCT = 'SET_PRODUCT';
export const SET_PARTNER = 'SET_PARTNER';
export const SET_CUSTOMER = 'SET_CUSTOMER';
export const SET_CONTRACT_DATA = 'SET_CONTRACT_DATA';
export const SET_ACCOUNT_HOLDER = 'SET_ACCOUNT_HOLDER';
export const SET_BANK_ACCOUNT = 'SET_BANK_ACCOUNT';
export const SET_CONTRACT_NUMBER = 'SET_CONTRACT_NUMBER';
export const RESET_CONTRACT_STORE = 'RESET_CONTRACT_STORE';
export const SET_SMS_ID = 'SET_SMS_ID';
export const SEARCH_CONTRACT = 'SEARCH_CONTRACT';
export const SEARCH_CONTRACT_FOR_LIST = 'SEARCH_CONTRACT_FOR_LIST';
export const SET_CONTRACT_LIST = 'SET_CONTRACT_LIST';
export const SET_CONTRACT_LIST_LINKS = 'SET_CONTRACT_LIST_LINKS';
export const SET_CONTRACT_LIST_PAGEINFO = 'SET_CONTRACT_LIST_PAGEINFO';
export const SET_ATTRIBUTES = 'SET_ATTRIBUTES';
export const SET_DYNAMIC_DATA = 'SET_DYNAMIC_DATA';
export const SET_IS_MODIFY = 'SET_IS_MODIFY';

export function* saveModifiedContract(action) {
    yield put({ type: SET_LOADING, val: true });
    const attributes = yield select((state: RootState) => state?.contract?.attributes);
    const productGroupList = yield select((state: RootState) => state?.unit?.productGroupList);
    const productBrandList = yield select((state: RootState) => state?.unit?.productBrandList);
    const productForm = yield select((state: RootState) => state?.form?.productForm?.values);
    const getProductData = yield select((state: RootState) => state?.form?.productForm?.values);
    const warrantyList = yield select((state: RootState) => state?.unit?.warrantyList);
    const getModels = yield select((state: RootState) => state?.contract);
    const projectProperties = yield select((state: RootState) => state?.contract?.projectProperties);

    // const contractNu;

    const payload = {
        accountHolderEmail: getModels?.accountHolderModel?.emailAh,
        accountHolderLanguageId: getModels?.accountHolderModel?.languageAh,
        accountHolderName: getModels?.accountHolderModel?.customerNameAh,
        accountHolderPhone: getModels?.accountHolderModel?.phoneNumberAh,
        articlePrice: getModels?.productModel?.price,
        articleType: getModels?.productModel?.model,
        brandId: getModels?.productModel?.brand,
        comment: getModels?.productModel?.comment,
        contractAddress: {
            countryCode: getModels?.customerModel?.country,
            city: getModels?.customerModel?.city,
            postcode: getModels?.customerModel?.postCode,
            street: getModels?.customerModel?.street,
            streetNumber: getModels?.customerModel?.houseNumber,
            // postbox: getFormData?.box,
        },
        accountHolderAddress: {
            city: getModels?.accountHolderModel?.cityAh,
            countryCode: getModels?.accountHolderModel?.countryAh,
            postcode: getModels?.accountHolderModel?.postCodeAh,
            street: getModels?.accountHolderModel?.streetAh,
            streetNumber: getModels?.accountHolderModel?.houseNumberAh,
        },
        contractEmail: getModels?.customerModel?.email,
        contractNumber: action.val,
        contractedPhoneNumber: getModels?.customerModel?.phoneNumber,

        employeeId: getModels?.partnerModel?.employee,
        groupId: getModels?.productModel?.group,
        ibanNumber: getModels?.bankAccountModel?.iban,
        languageId: getModels?.customerModel?.language,
        lastName: getModels?.customerModel?.customerName,
        partnerId: getModels?.partnerModel?.partner,
        phoneNumber: getModels?.customerModel?.phoneNumber,
        priceId: warrantyList.filter((data) => getProductData?.warranty == data?.warrantyId)[0]?.priceId,
        receiptNumber: getModels?.partnerModel?.receiptNumber,
        salesDate: dayjs(new Date(getModels?.partnerModel?.sellingDate)).format('YYYY-MM-DD'),
        shipDate: dayjs(new Date(getModels?.partnerModel?.deliveryDate)).format('YYYY-MM-DD'),
        serialNumber: getModels?.productModel?.serial,
        shopId: getModels?.partnerModel?.shop,
        taxIdentificationNumber: getModels?.customerModel?.vatNumber,
        warrantySalesDate: dayjs(new Date(getModels?.partnerModel?.deliveryDate)).format('YYYY-MM-DD'),
        warrantySalesPrice: getModels?.productModel?.warrantySellingPrice,
        warrantyProductId: getProductData?.warranty,
    };
    const dynamicAttributes: any[] = [];
    if (attributes.filter((data) => data?.name === 'PRODUCT_GROUP').length > 0) {
        dynamicAttributes.push({
            attributeInventoryId: attributes.filter((data) => data?.name === 'PRODUCT_GROUP')[0]?.id,
            attributeValue: productGroupList.filter((data) => data?.value == productForm?.group)[0]?.label,
        });
    }
    if (attributes.filter((data) => data?.name === 'ARTICLE_PRICE').length > 0) {
        dynamicAttributes.push({
            attributeInventoryId: attributes.filter((data) => data?.name === 'ARTICLE_PRICE')[0]?.id,
            attributeValue: productForm?.price,
        });
    }
    if (attributes.filter((data) => data?.name === 'BRAND').length > 0) {
        dynamicAttributes.push({
            attributeInventoryId: attributes.filter((data) => data?.name === 'BRAND')[0]?.id,
            attributeValue: productBrandList.filter((data) => data?.value == productForm?.brand)[0]?.label,
        });
    }
    if (dynamicAttributes.length > 0) {
        payload['dynamicAttributes'] = dynamicAttributes;
    }
    try {
        const response = yield ContractService.saveModifiedContract(payload);
        if (response.status === 200) {
            yield put({ type: SET_CONTRACT_NUMBER, val: action.val });
        } else {
            if (response.status === 400 && response?.data?.message.includes('email_is_black_listed')) {
                yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 413 } });
            } else if (response.status === 400 && response?.data?.message.includes('wrong_email_syntax')) {
                yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 414 } });
            } else if (response.status === 400 && response?.data?.message.includes('host_does_not_exist')) {
                yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 415 } });
            } else if (response.status === 400 && response?.data?.message.includes('invalid_mx_record')) {
                yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 416 } });
            } else if (response.status === 406 && response?.data?.message.includes('contract can be registered only the warranty start date')) {
                yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 417 } });
            } else if (response.status === 406 && response?.data?.message.includes('The contract can be registered until')) {
                setNotification(
                    `${i18next.t('common:error_handling.error')}`,
                    `${i18next.t('common:common_errors.the_contract_can_be_registered_until', { days: projectProperties?.days_to_register })}`,
                    'danger'
                );
                // yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 418 } });
            } else if (response.status === 406 && response?.data?.message.includes('You are not authorised to register a contract with a warranty selling date more then')) {
                setNotification(
                    `${i18next.t('common:error_handling.error')}`,
                    `${i18next.t('common:common_errors.the_contract_can_be_registered_until', { days: projectProperties?.days_ws_pre_reg })}`,
                    'danger'
                );
                // yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 419 } });
            } else {
                yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: response?.status } });
            }
        }
    } catch (error) {

        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: error?.response?.status } });
    } finally {
        yield put({ type: SET_LOADING, val: false });
    }
}
export function* getAttributes() {
    yield put({ type: SET_LOADING, val: true });

    try {
        const response = yield ContractService.getAttributes();
        if (response?.status === 200) {
            yield put({ type: SET_ATTRIBUTES, val: response?.data });
        } else {
            yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: response?.status } });
        }
    } catch (error) {
        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 500 } });
    } finally {
        yield put({ type: SET_LOADING, val: false });
    }
}
export function* getDynamicData(action) {
    yield put({ type: SET_LOADING, val: true });

    try {
        const response = yield ContractService.getDynamicData(action?.val?.partnerId, action?.val?.contractNumber);
        if (response?.status === 200) {
            yield put({ type: SET_DYNAMIC_DATA, val: response?.data });
        } else {
            yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: response?.status } });
        }
    } catch (error) {
        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 500 } });
    } finally {
        yield put({ type: SET_LOADING, val: false });
    }
}
export function* getContract(action) {
    yield put({ type: SET_LOADING, val: true });
    const requestBody = action.val;
    try {
        // PartnerId is neccessary for product GROUP and BRAND
        yield put(change('partnerForm', 'partner', requestBody.partnerId));
        // ! GET UNIT data
        yield put({ type: GET_PRODUCT_GROUP_LIST });
        yield put({ type: GET_PRODUCT_BRAND_LIST });
        yield put({ type: GET_SHOP_LIST });
        yield put({ type: GET_PARTNER_LIST });
        // yield put({ type: GET_WARRANTY_LIST });
        yield put({ type: GET_ACCOUNT });

        const contractResponse = yield ContractService.searchContract(requestBody);
        const accountResponse = yield ContractService.getAccount(requestBody.partnerId, requestBody.contractNumber);
        const deviceResponse = yield UnitService.getDevice(contractResponse?.data?._embedded?.contracts[0].deviceId);
        const bankResponse = yield UnitService.bankList(accountResponse?.data?.bankCode, accountResponse?.data?.bankCountryId);

        /** Extend bank response
         * ! In api layer it doesn't work to edit response
         */
        const bank = bankResponse?.data;
        bank.bankName = bank.bankName;
        bank.bankCountry = accountResponse?.data?.bankCountryId;
        bank.iban = accountResponse.data.ibanNumber;
        /**
         * ! ---------------------------------------------
         */

        // ! Create instance
        const ContractInstance = new ContractDataModel(contractResponse?.data?._embedded?.contracts[0] as ContractData);
        const customerInstance = new CustomerModel(contractResponse?.data?._embedded?.contracts[0] as Customer);
        const accountHolderInstance = new AccountHolderModel(accountResponse?.data as AccountHolder);
        const bankInstance = new BankAccountModel(bank as BankAccount);
        const partnerInstance = new PartnerModel(contractResponse?.data?._embedded?.contracts[0] as PartnerModel);
        const deviceInstance = new ProductModel(deviceResponse?.data as ProductModel);
        deviceInstance.comment = contractResponse?.data?._embedded?.contracts[0]?.comment ?? '';
        // ! Store instance
        ContractDataModel.storeContract(ContractInstance);
        CustomerModel.storeCustomer(customerInstance);
        AccountHolderModel.storeAccountHolder(accountHolderInstance);
        BankAccountModel.storeBankAccount(bankInstance);
        PartnerModel.storePartner(partnerInstance);
        ProductModel.storeProduct(deviceInstance);

        // ! Populate forms
        CustomerModel.populateForm();
        AccountHolderModel.populateForm();
        BankAccountModel.populateForm();
        // PartnerModel.populateForm();
        ProductModel.populateForm();
        yield put({ type: GET_WARRANTY_LIST });
        // CustomerModel.populateForm();
        yield put(change('productForm', 'warranty', contractResponse?.data?._embedded?.contracts[0].warrantyProduct.id));
        // yield put(change('productForm', 'warranty', contractResponse?.data?._embedded?.contracts[0].warrantyProduct.id));
    } catch (error) {
    } finally {
        yield put({ type: SET_LOADING, val: false });
    }
}
export function* searchContract(action) {
    yield put({ type: SET_LOADING, val: true });

    const payload = {
        page: action?.val?.page,
        size: action?.val?.size,
        contractNumber: action?.val?.contractNumber,
        serialNumber: action?.val?.serialNumber,
        customerName: action?.val?.customerName,
        employeeName: action?.val?.employeeName,
        contractRegistrationDateFrom: action?.val?.contractRegistrationDateFrom,
        contractRegistrationDateTo: action?.val?.contractRegistrationDateTo,
    };

    try {
        const response = yield ContractService.searchContract(payload);

        yield put({ type: SET_CONTRACT_LIST, val: response?.data?._embedded?.contracts });
        yield put({ type: SET_CONTRACT_LIST_LINKS, val: response?.data?._links });
        yield put({ type: SET_CONTRACT_LIST_PAGEINFO, val: response?.data?.page });
    } catch (error) {
        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: error?.response?.status } });
    } finally {
        yield put({ type: SET_LOADING, val: false });
    }
}
export function* searchContractForList(action) {
    yield put({ type: SET_LOADING, val: true });

    const payload = {
        page: action?.val?.page,
        size: action?.val?.size,
        contractNumber: action?.val?.contractNumber,
        serialNumber: action?.val?.serialNumber,
        customerName: action?.val?.customerName,
        employeeName: action?.val?.employeeName,
        contractRegistrationDateFrom: action?.val?.contractRegistrationDateFrom,
        contractRegistrationDateTo: action?.val?.contractRegistrationDateTo,
    };

    try {
        const response = yield ContractService.searchContractForList(payload);
        if (!response?.data?._embedded?.contracts) {
            yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 499 } });
        }

        yield put({ type: SET_CONTRACT_LIST, val: response?.data?._embedded?.contracts });
        yield put({ type: SET_CONTRACT_LIST_LINKS, val: response?.data?._links });
        yield put({ type: SET_CONTRACT_LIST_PAGEINFO, val: response?.data?.page });
    } catch (error) {
        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: error?.response?.status } });
    } finally {
        yield put({ type: SET_LOADING, val: false });
    }
}

export function* getProjectProperties(actionPayload) {
    yield put({ type: SET_LOADING, val: true });

    try {
        const queryParams = {
            prtId: actionPayload?.val,
        };

        const response = yield ContractService.getProjectProperties(queryParams);
        if (response?.status === 200) {
            yield put({ type: SET_PROJECT_PROPERTIES, val: response?.data[0] });
        } else {
            yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: response?.status } });
        }
    } catch (error) {
        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 500 } });
    } finally {
        yield put({ type: SET_LOADING, val: false });
    }
}
export function* getDiaries(actionPayload) {
    yield put({ type: SET_LOADING, val: true });

    try {
        // const getPartnerData = yield select((state: RootState) => state?.contract?.partnerModel);
        // const getContractNumber = yield select((state: RootState) => state?.contract?.contractNumber);

        const response = yield ContractService.getDiaries(actionPayload?.val?.partnerId, actionPayload?.val?.contractNumber);
        if (response?.status === 200) {
            yield put({ type: SET_DIARIES, val: response?.data });
        } else {
            yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: response?.status } });
        }
    } catch (error) {
        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 500 } });
    } finally {
        yield put({ type: SET_LOADING, val: false });
    }
}

export function* sendMail() {
    yield put({ type: SET_LOADING, val: true });
    const getPartnerData = yield select((state: RootState) => state?.contract?.partnerModel);
    const getContractNumber = yield select((state: RootState) => state?.contract?.contractNumber);
    try {
        const payload = {
            partnerId: getPartnerData?.partner,
            contractNumber: getContractNumber,
        };
        const response = yield ContractService.sendMail(payload);
        if (response?.status === 200) {
            return;
        } else {
            yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: response?.status } });
        }
    } catch (error) {
        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 500 } });
    } finally {
        yield put({ type: SET_LOADING, val: false });
    }
}
export function* sendSms() {
    return;
    yield put({ type: SET_LOADING, val: true });
    const getPartnerData = yield select((state: RootState) => state?.contract?.partnerModel);
    const contractNumber = yield select((state: RootState) => state?.contract?.contractNumber);
    const phoneNumber = yield select((state: RootState) => state?.contract?.customerModel?.phoneNumber) ?? '"phone number"';
    const payload = {
        phoneNumber: phoneNumber,
    };
    try {
        const response = yield ContractService.sendSmsCode(payload, getPartnerData?.partner, contractNumber);
        if (response?.status === 200) {
            yield put({ type: SET_SMS_ID, val: response?.data?.smsId });
            // Sending sms successfully doesn't trigger notification
            return;
        } else {
            // Else does
            yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: response?.status } });
        }
    } catch (error) {
        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 500 } });
    } finally {
        yield put({ type: SET_LOADING, val: false });
    }
}
export function* verifySmsCode() {
    yield put({ type: SET_LOADING, val: true });
    const smsId = yield select((state: RootState) => state?.contract?.smsId);
    const paperlessCode = yield select((state: RootState) => (state?.form?.paperless as Record<'values', Record<'code', string>>)?.values?.code);

    const payload: smsAuthType = {
        smsId: smsId,
        smsCode: paperlessCode,
    };
    try {
        const response = yield ContractService.verifySmsCode(payload);
        if (response.status === 200) {
            yield put({ type: SET_CONTRACT_SAVED, val: true });
        } else {
            yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'verify_errors', errorCode: response?.status } });
        }
    } catch (error) {
        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'verify_errors', errorCode: 500 } });
    } finally {
        yield put({ type: SET_LOADING, val: false });
    }
}

/**
 * Save new contract
 */
export function* saveNewContract() {
    yield put({ type: SET_LOADING, val: true });
    const attributes = yield select((state: RootState) => state?.contract?.attributes);
    const productGroupList = yield select((state: RootState) => state?.unit?.productGroupList);
    const productBrandList = yield select((state: RootState) => state?.unit?.productBrandList);
    const productForm = yield select((state: RootState) => state?.form?.productForm?.values);
    const partnerForm = yield select((state: RootState) => state?.form?.partnerForm?.values);
    const getProductData = yield select((state: RootState) => state?.form?.productForm?.values);
    const warrantyList = yield select((state: RootState) => state?.unit?.warrantyList);
    const projectProperties = yield select((state: RootState) => state?.contract?.projectProperties);
    const getModels = yield select((state: RootState) => state?.contract);
    const payload = {
        contract: {
            articleType: getModels?.productModel?.model,
            articlePrice: getModels?.productModel?.price,
            brandId: getModels?.productModel?.brand,
            city: getModels?.customerModel?.city,
            comment: getModels?.productModel?.comment,
            countryId: getModels?.customerModel?.country,
            email: getModels?.customerModel?.email,
            employeeId: getModels?.partnerModel?.employee,
            employeeName: partnerForm?.newEmployee ?? '',
            groupId: getModels?.productModel?.group,
            languageId: getModels?.customerModel?.language,
            lastname: getModels?.customerModel?.customerName,
            partnerId: getModels?.partnerModel?.partner,
            phoneNumber: getModels?.customerModel?.phoneNumber,
            postcode: getModels?.customerModel?.postCode,
            priceId: warrantyList.filter((data) => getProductData?.warranty == data?.warrantyId)[0]?.priceId,
            receiptNumber: getModels?.partnerModel?.receiptNumber,
            salesDate: dayjs(new Date(getModels?.partnerModel?.sellingDate)).format('YYYY-MM-DD'),
            shipDate: dayjs(new Date(getModels?.partnerModel?.deliveryDate)).format('YYYY-MM-DD'),
            serialNumber: getModels?.productModel?.serial,
            shopId: getModels?.partnerModel?.shop,
            status: 'A',
            street: getModels?.customerModel?.street,
            streetNumber: getModels?.customerModel?.houseNumber,
            taxIdentificationNumber: getModels?.customerModel?.vatNumber,
            warrantySalesDate: dayjs(new Date(getModels?.partnerModel?.deliveryDate)).format('YYYY-MM-DD'),
            warrantySalesPrice: getModels?.productModel?.warrantySellingPrice,

            // warrantyTypeId: getModels?.productModel?.warranty,
            warrantyProductId: getProductData?.warranty,
        },
        account: {
            bankCode: getModels?.bankAccountModel?.iban?.slice(4, 7),
            bankCountryId: getModels?.bankAccountModel?.bankCountry,
            city: getModels?.accountHolderModel?.cityAh,
            countryId: getModels?.accountHolderModel?.countryAh,
            customerName: getModels?.accountHolderModel?.customerNameAh,
            email: getModels?.accountHolderModel?.emailAh,
            ibanNumber: getModels?.bankAccountModel?.iban.toUpperCase(),
            languageId: getModels?.accountHolderModel?.languageAh,
            phoneNumber: getModels?.accountHolderModel?.phoneNumberAh,
            postcode: getModels?.accountHolderModel?.postCodeAh,
            street: getModels?.accountHolderModel?.streetAh,
            streetNumber: getModels?.accountHolderModel?.houseNumberAh,
        },
        dynamicAttributes: [
            {
                attributeInventoryId: attributes.filter((data) => data?.name === 'PRODUCT_GROUP')[0].id,
                attributeValue: productGroupList.filter((data) => data?.value == productForm?.group)[0]?.label,
            },
            {
                attributeInventoryId: attributes.filter((data) => data?.name === 'ARTICLE_PRICE')[0].id,
                attributeValue: productForm?.price,
            },
            {
                attributeInventoryId: attributes.filter((data) => data?.name === 'BRAND')[0].id,
                attributeValue: productBrandList.filter((data) => data?.value == productForm?.brand)[0]?.label,
            },
            // {
            //     attributeInventoryId: attributes.filter((data) => data?.name === 'EXTERNAL_PROD_SERVICE_DATE')[0].id,
            //     attributeValue: '2025-01-27',
            // },
            // {
            //     attributeInventoryId: attributes.filter((data) => data?.name === 'EXTERNAL_PROD_SERVICE_CODE')[0].id,
            //     attributeValue: 'Lorem',
            // },
        ],
    };
    const response = yield ContractService.saveContract(payload);
    if (response.status === 200) {
        sessionStorage.setItem('contractNumber', response?.data?.contractNumber);
        sessionStorage.setItem('partnerId', getModels?.partnerModel?.partner);

        yield put({ type: SET_CONTRACT_NUMBER, val: response?.data?.contractNumber });
        yield put({ type: SEND_SMS });
    } else {
        // console.log('projectProperties', projectProperties);
        if (response.status === 400 && response?.data?.message.includes('email_is_black_listed')) {
            yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 413 } });
        } else if (response.status === 400 && response?.data?.message.includes('wrong_email_syntax')) {
            yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 414 } });
        } else if (response.status === 400 && response?.data?.message.includes('host_does_not_exist')) {
            yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 415 } });
        } else if (response.status === 400 && response?.data?.message.includes('invalid_mx_record')) {
            yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 416 } });
        } else if (response.status === 406 && response?.data?.message.includes('contract can be registered only the warranty start date')) {
            yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 417 } });
        } else if (response.status === 406 && response?.data?.message.includes('The contract can be registered until')) {
            setNotification(
                `${i18next.t('common:error_handling.error')}`,
                `${i18next.t('common:common_errors.the_contract_can_be_registered_until', { days: projectProperties?.days_to_register })}`,
                'danger'
            );
            // yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 418 } });
        } else if (response.status === 406 && response?.data?.message.includes('You are not authorised to register a contract with a warranty selling date more then')) {
            setNotification(
                `${i18next.t('common:error_handling.error')}`,
                `${i18next.t('common:common_errors.the_contract_can_be_registered_until', { days: projectProperties?.days_ws_pre_reg })}`,
                'danger'
            );
            // yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 419 } });
        } else {
            yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: response?.status } });
        }
    }
    yield put({ type: SET_LOADING, val: false });
}
